import { createContext } from "react";

import { Context, User } from "../api/user";

export const MeContext = createContext<Context>({
    currentUser: {} as User,
    clientId: "",
});
